export const SeriesPath = (channel: number, path?: string) => `/v4/admin/series/${channel}${path ? path : ''}`;
